































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

interface ChecklistItem {
  key: string;
  label: string;
  y: boolean;
  t: boolean;
  v: boolean;
  hasDetail?: boolean;
  detail?: string;
  detailPlaceholder?: string;
}

@Component
export default class ChecklistYTV extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ required: true }) items!: ChecklistItem[];
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) disableV!: boolean;

  localItems: ChecklistItem[] = [];

  @Watch("items", { immediate: true, deep: true })
  onItemsChanged(val: ChecklistItem[]) {
    this.localItems = (val || []).map(item => ({ ...item }));
  }

  onYChange(idx: number) {
    if (this.localItems[idx].y) {
      this.localItems[idx].t = false;
    }
    this.emitUpdate();
  }

  onTChange(idx: number) {
    if (this.localItems[idx].t) {
      this.localItems[idx].y = false;
    }
    this.emitUpdate();
  }

  emitUpdate() {
    this.$emit("update", this.localItems.map(item => ({ ...item })));
  }
}
